/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.ExhibitorWindow = function( txt, fxStyle) {
    var Dialog = expocadfx.Dialog;
    var data = expocadfx.fxData;
    var config = expocadfx.config;
    var util = expocadfx.util;
    var elemById = expocadfx.element.elementById;
    
    var body = document.getElementsByTagName( "body")[0];
    var exhForm = elemById( "exhibitorInfo");
    var dialog = null;
    var i = 0;
    //  print button is optional  !!!???
    var leftButtons = [];
    if( config.bPopUpShare) {
        leftButtons.push( { id:"ei_email", label:String.fromCharCode( 0xf1e0) });
    }
    if( config.bPopUpPrint) {
        leftButtons.push( { id:"ei_print", label:String.fromCharCode( 0xf02f) });
    }
    var shareContainer = document.createElement('ul');
    if (location.protocol !== 'https:' && location.hostname !== "localhost"){
        shareContainer.innerHTML = "<li><a id='shareEma' href='#'><i class='fas fa-envelope'></i></a></li>" +
        "<li><a id='sharePage' href='#'><i class='fas fa-file'></i></a></li>" +
        "<li><a id='shareFac'><i class='fab fa-facebook-f'></i></a></li>" +
        "<li><a id='shareTwi'><i class='fab fa-twitter'></i></a></li>";
    } else {
        shareContainer.innerHTML = "<li><a id='shareEma' href='#'><i class='fas fa-envelope'></i></a></li>" +
        "<li><a id='shareCop' href='#'><i class='fas fa-copy'></i></a></li>" +
        "<li><a id='shareFac'><i class='fab fa-facebook-f'></i></a></li>" +
        "<li><a id='shareTwi'><i class='fab fa-twitter'></i></a></li>";
    }

    var obj = {
        title: txt.EXHIBITOR_INFO,
        headerBackgroudColor: fxStyle.windowHeader.clrBg !== "" ? 
            fxStyle.windowHeader.clrBg : fxStyle.mainHeader.clrBg,
        headerTextColor: fxStyle.windowHeader.clrText !== "" ? 
            fxStyle.windowHeader.clrText : fxStyle.mainHeader.clrText,
        cancelLabel: txt.CLOSE,
        width: 400,
        height: 400,
        posX: data.viewportWidth / 3,
        posY: data.viewportHeight / 3,
        leftButtons: leftButtons,
        draggable: true
    };
    
    if( fxStyle.windowHeader.gradBg !== "") {
        obj.headerBackground = fxStyle.windowHeader.gradBg;
    }
    else {
        if( fxStyle.windowHeader.clrBg === "" && fxStyle.mainHeader.gradBg !== "") {
            obj.headerBackground = fxStyle.mainHeader.gradBg;
        }
    }
    
    dialog = new Dialog( obj, body, elemById("mask"));
    
    exhForm.style.display = "block";
    dialog.content.appendChild( exhForm);

    var divs = exhForm.getElementsByClassName( "divider");
    for( i = 0; i < divs.length; i++) {
        divs[i].style.backgroundColor = obj.headerBackgroudColor;
        divs[i].style.color = obj.headerTextColor;
    }
//    elemById("ei_email").innerHTML = '<i class="fa fa-envelope"></i>';
    if(config.bPopUpShare) {
        util.addClass( elemById("ei_email"), "icon");
        elemById("ei_email").title = "Share";
        elemById("ei_email").appendChild(shareContainer);
        elemById("shareEma").title = txt.TT_MAIL_FRIEND;
        elemById("shareFac").title = "Share on Facebook"
        elemById("shareTwi").title = "Share on Twitter"
        if (location.protocol !== 'https:' && location.hostname !== "localhost"){
            elemById("sharePage").title = "Open in New Tab"
        } else {
            elemById("shareCop").title = "Copy Link"
        }
    }

    
    if( config.bPopUpPrint) {
        util.addClass( elemById("ei_print"), "icon");
        elemById("ei_print").title = txt.TT_PRINT_EXHIBITOR;
    }
    
    return dialog;
};